import { AccessRole, StakeholderRole } from '../../../../types/stakeholder.types';
import { SignatureStatus } from '../enums/signature-status.const';

export const canSendSignatureReminderForRole = ({
  accessRole,
  roleInCompany,
}: {
  accessRole?: AccessRole | null;
  roleInCompany?: StakeholderRole;
}): boolean => {
  if (roleInCompany === StakeholderRole.STAKEHOLDER && accessRole !== AccessRole.CONTRIBUTOR) {
    return false;
  }
  if (accessRole === AccessRole.AUDITOR) {
    return false;
  }
  if (roleInCompany === StakeholderRole.ADMIN) {
    return true;
  }
  if (roleInCompany === StakeholderRole.CONTRIBUTOR) {
    return true;
  }
  if (accessRole === AccessRole.CONTRIBUTOR) {
    return true;
  }
  return false;
};

export const isSignatureReminderEligibleStatus = (status: SignatureStatus): boolean =>
  status === SignatureStatus.SIGNATURE_PENDING || status === SignatureStatus.PARTIALLY_SIGNED;
